<template>
	<div class="bj" v-loading="lods" element-loading-text="提交中..." element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<div class="contents" style="margin-bottom: 6px;">
			<div class="logo"><img src="../../assets/index/logo.png" /></div>
			<div class="nav">
				<el-row>
					<el-col :span="21">
						<div class="grid-content" @click="goTo('/course')">
							<div><img src="../../assets/left.svg" />离开考试</div>
						</div>

					</el-col>
					<el-col :span="3">
						<el-popover placement="bottom" width="150" trigger="click">

							<div class="listbut" @click="logoutCms()"><i class="el-icon-remove"></i>退出登录</div>
							<div class="userinfo" slot="reference">
								<div>
									<img :src="userInfos.avatar" />
								</div>
								<div>{{userInfos.nickname}}<i class="el-icon-caret-bottom"></i></div>
							</div>
						</el-popover>
					</el-col>
				</el-row>
			</div>
		</div>
		<!-- <heads></heads> -->
		<div class="content">
			<div class="exam-left">
				<div>答题规则</div>
				<div v-html="configs.dtgz">
				</div>
			</div>
			<div class="exam-middle">
				<div class="title">{{title}}考试</div>
				<div class="Tips"><i class="el-icon-s-opportunity"></i>{{configs.zysx}}
				</div>
				<div style="width: 100%;height: 2px;background: #F2F2F2;"></div>
				<div class="Test">
					<!-- <div class="Test-tit">
						<span v-if="(idx+1)<=allnum && (idx+1)<=nums ">单选题。（共{{allnum}}道小题，每题{{mark}}分）</span>
						<span
							v-if="(idx+1)<=allnum+nums2 && (idx+1)>allnum">{{nums}}{{idx}}{{allnum}}{{nums2}}多选题。（共{{allnum}}道小题，每题{{mark}}分）</span>
						<span v-if="stat===3">判断题。（共{{allnum}}道小题，每题{{mark}}分）</span>
					</div> -->
					<div class="Test-tit" v-if="quseType===1">单选题（共{{quseContent.count1}}道小题，每题{{quseContent.type1}}分）
					</div>
					<div class="Test-tit" v-if="quseType===2">多选题（共{{quseContent.count2}}道小题，每题{{quseContent.type2}}分）
					</div>
					<div class="Test-tit" v-if="quseType===3">判断题（共{{quseContent.count3}}道小题，每题{{quseContent.type3}}分）
					</div>
					<div class="Test-tit" v-if="quseType===4">简答题（共{{quseContent.count4}}道小题，每题{{quseContent.type4}}分）
					</div>
					<div v-for="(item,index) in Question " :key="item.id">

						<div v-show="idx==index">
							<div>{{index+1}}.{{item.title}}</div>
							<div>
								<!-- 单选选项 -->
								<el-radio-group v-model="finishParmas.answers[index].d" :border="true" size="medium"
									v-if="item.status==1 || item.status==3">
									<el-radio label="A" :border="true" size="medium">{{item.A }}</el-radio><br />
									<el-radio label="B" :border="true" size="medium">{{item.B }}</el-radio><br />
									<el-radio label="C" v-show="item.C" :border="true" size="medium">{{item.C }}
									</el-radio><br />
									<el-radio label="D" v-show="item.D" :border="true" size="medium">{{item.D }}
									</el-radio><br />
								</el-radio-group>
								<!-- 多选选项 -->
								<el-checkbox-group @input="change($event)" v-model="finishParmas.answers[index].d"
									fill="#2FC047" size="medium" v-if="item.status==2">
									<el-checkbox label="A" :border="true" size="medium">{{item.A }}</el-checkbox>
									<br />
									<el-checkbox label="B" :border="true" size="medium">{{item.B }}</el-checkbox>
									<br />
									<el-checkbox label="C" :border="true" size="medium">{{item.C }}</el-checkbox>
									<br />
									<el-checkbox label="D" v-show="item.D" :border="true" size="medium">{{item.D }}
									</el-checkbox><br />
									<el-checkbox label="E" v-show="item.E" :border="true" size="medium">{{ item.E }}
									</el-checkbox><br />
									<el-checkbox label="F" v-show="item.F" :border="true" size="medium">{{ item.F }}
									</el-checkbox><br />
								</el-checkbox-group>
							</div>
						</div>

					</div>
					<div class="Toggle">
						<div>
							<el-button type="primary" plain size="small" @click="back()" v-if="idx>0">上一题
							</el-button>
						</div>
						<div>
							<el-button type="primary" plain size="small" @click="next()" v-if="idx<Question.length-1">
								下一题
							</el-button>
						</div>
					</div>
				</div>
			</div>
			<div class="exam-right">
				<div class="times">
					<div><img src="../../assets/time.svg" /></div>
					<div>答题计时</div>
					<div>
						{{ formatTime(countdown) }}
					</div>
				</div>
				<div class="submits" @click="submitt()">
					<div><img src="../../assets/exam/success.svg" /></div>
					<div>我要交卷</div>
				</div>
				<div class="Answer">
					<div class="Answer—tits">单选题</div>
					<div class="Answer—list">
						<el-tag v-if="item.status==1" :type="finishParmas.answers[index].d.length != 0 ?'':'info'"
							v-for="(item,index) in Question" :key="item.id" @click="sheet(index,item)">
							{{index+1}}
						</el-tag>

					</div>
					<div class="Answer—tits">多选题</div>
					<div class="Answer—list">
						<el-tag v-if="item.status==2" :type="finishParmas.answers[index].d.length != 0 ?'':'info'"
							v-for="(item,index) in Question" :key="item.id" @click="sheet(index,item)">
							{{index+1}}
						</el-tag>
					</div>
					<div class="Answer—tits">判断题</div>
					<div class="Answer—list">
						<el-tag v-for="(item,index) in Question" :key="item.id" v-if="item.status==3"
							:type="finishParmas.answers[index].d.length != 0 ?'':'info'" @click="sheet(index,item)">
							{{index+1}}
						</el-tag>

					</div>
				</div>
			</div>
		</div>
		<Foot></Foot>

	</div>
</template>

<script>
	import Heads from '@/components/head.vue'
	import Foot from '@/components/foot.vue'
	export default {
		components: {
			Foot,
			Heads
		},
		data() {
			return {
				lods: false,
				timer: null,
				userInfos: {
					nickname: '',
					avatar: '',
				},
				config: {
					logo_big: ''
				},
				title: '',
				Question: [],
				course_id: '',
				answer: [],
				finishParmas: {
					fraction_id: null,
					time: 10,
					answers: [],
				},
				idx: 0,
				//答对题数
				correct: 0,
				//答错题数
				mistake: 0,
				//答题卡
				typs: 'info',
				datas: [],
				allnum: '',
				totalScore: 0,
				//分数
				mark: '',
				countdown: 10, // 考试剩余时间，假设为3600秒（1小时）
				time: 0,
				configs: [],
				//单选
				nums: 0,
				nums2: 0,
				createtime: '',
				end_time: '',
				stat: 0,
				quseType: null,
				quseContent: {
					type1: '0',
					type2: '0',
					type3: '0',
					type4: '0',
					count1: '0',
					count2: '0',
					count3: '0',
					count4: '0',
				}
			};

		},

		created() {
			this.configs = JSON.parse(sessionStorage.getItem('configs'))
			this.userInfos = JSON.parse(sessionStorage.getItem('userInfo'))
			this.course_id = this.$route.query.course_id
			this.title = this.$route.query.title
			this.getQuestion()
			this.times()
		},

		mounted() {
			//阻止F5刷新
			this.stopF5Refresh();
			this.timer = setInterval(() => {
				this.countdown--; // 每秒减少1秒
				//console.log(this.countdown)
				if (this.countdown === 0) {
					clearInterval(this.timer); // 清除定时器
					this.timer = null
					this.$confirm('本次考试已结束，请确认交卷！', '提示', {
						confirmButtonText: '确定',
						showCancelButton: false,
						closeOnClickModal: false,
						showClose: false,
						type: 'warning'
					}).then(() => {
						this.lods = true
						this.submit()
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消'
						});
					});
				}
			}, 1000);
			// 监听浏览器的 beforeunload 事件
			window.addEventListener('beforeunload', this.handleBeforeUnload);
		},
		beforeDestroy() {
			clearInterval(this.timer); // 清除定时器
			this.timer = null

		},
		methods: {
			handleBeforeUnload(event) {
				// 取消刷新时的默认提示信息
				event.preventDefault();
				// Chrome需要返回一个空字符串
				event.returnValue = '';
			},
			//考试开始时间
			times() {
				this.createtime = this.$getCurrentTime();
			},
			//考试结束时间
			times2() {
				this.end_time = this.$getCurrentTime();
			},
			//阻止F5刷新
			stopF5Refresh() {
				document.onkeydown = function(e) {
					var evt = window.event || e;
					var code = evt.keyCode || evt.which;
					if (code == 116) {
						if (evt.preventDefault) {
							evt.preventDefault();
						} else {
							evt.keyCode = 0;
							evt.returnValue = false;
						}
					}
				};
			},
			//倒计时
			formatTime(time) {
				const hours = Math.floor(time / 3600);
				const minutes = Math.floor((time % 3600) / 60);
				const seconds = time % 60;
				return `${this.padZero(hours)}:${this.padZero(minutes)}:${this.padZero(seconds)}`;
			},
			padZero(num) {
				return String(num).padStart(2, '0');
			},
			change(e) {
				this.$forceUpdate()
			},
			//获取考试题目
			getQuestion() {
				this.$http({
						method: 'GET',
						url: '/Exam/getQuestion?course_id=' + this.course_id,
						headers: {
							requireAuth: true // 这里通过设置requireAuth为true来启用token检查
						},
					})
					.then(response => {
						//console.log(response)
						if (response.code == 1) {
							this.datas = response.data
							this.Question = response.data.data
							this.nums = response.data.data[0].question.length
							this.nums2 = response.data.data[1].question.length
							this.countdown = response.data.courseConf.exam_time * 60
							this.time = response.data.courseConf.exam_time * 60
							this.configs.dtgz = response.data.courseConf.ksxz
							this.allnum = response.data.data[0].question.length
							// if (this.idx + 1 < this.allnum) {
							// 	this.mark = response.data.fraction.单选题;
							// } else if (this.idx + 1 + this.allnum < response.data.data[1].question.length) {
							// 	this.mark = response.data.fraction.多选题;
							// } else {
							// 	this.mark = response.data.fraction.判断题;
							// }
							const [firstQuestion, secondQuestion, thirdQuestion] = response.data.data;
							const arr = firstQuestion.question.concat(secondQuestion.question, thirdQuestion.question);
							this.finishParmas.answers.push(
								...arr.map((item) => ({
									sid: item.id,
									d: (item.status === 2) ? [] : "",
									ans: item.answer,
									status: item.status
								}))
							);
							this.Question = arr;
							// console.log(this.Question[0].status)
							if (this.Question.length > 0) {
								this.quseType = this.Question[0].status
								this.quseContent.type1 = this.datas.fraction.单选题
								this.quseContent.type2 = this.datas.fraction.多选题
								this.quseContent.type3 = this.datas.fraction.判断题
								this.quseContent.type4 = this.datas.fraction.简答题
								let countJSON = JSON.parse(this.datas.courseConf.questionjson)
								//console.log(countJSON)
								this.quseContent.count1 = countJSON.单选题
								this.quseContent.count2 = countJSON.多选题
								this.quseContent.count3 = countJSON.判断题
								this.quseContent.count4 = countJSON.简答题
							}
						} else {
							this.$message(response.msg);
						}

					})
					.catch(error => {
						console.log(error)
					})
			},
			goTo(path) {
				this.$confirm('您的考试尚未完成, 确定离开考试吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.defaultStay = path
					window.sessionStorage.setItem('leftMenuDefaultKey', path)
					this.$router.replace(path);
				}).catch(() => {

				});
			},
			// 退出
			logoutCms() {
				this.$confirm('是否继续退出系统?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.showLogout = false
					const loading = this.$loading({
						lock: true,
						text: '正在退出，请稍候...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					})
					setTimeout(() => {
						loading.close()
						sessionStorage.clear()
						this.$message({
							message: '已退出',
							type: 'success'
						})
						this.$router.replace({
							name: 'login'
						})
					}, 2000)
				}).catch(() => {

				});
			},

			//答题卡
			sheet(val, item) {
				//console.log(item)
				this.stat = item.status
				this.idx = val
				this.updateQuestion();
			},
			//上一题
			back() {
				this.idx--;
				this.updateQuestion();
			},
			//下一题
			next() {
				this.idx++;
				this.updateQuestion();
			},
			//更新题目信息
			updateQuestion() {
				const status = this.Question[this.idx].status;
				//console.log(status, 123)
				// if (status === 1) {
				// 	this.mark = this.datas.fraction.单选题;
				// } else if (status === 2) {
				// 	this.mark = this.datas.fraction.多选题;
				// } else {
				// 	this.mark = this.datas.fraction.判断题;
				// }
				// this.allnum = this.datas.data[status - 1].question.length;
				//
				this.quseType = status
			},
			submits() {
				this.$confirm('是否确认交卷?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					closeOnClickModal: false,
					type: 'warning'
				}).then(() => {
					this.lods = true
					this.submit()
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			submitt() {
				this.finishParmas.answers.forEach((element) => {
					this.typs = '';
					element.anser = {};

					if (element.status === 2) {
						var arr = element.d.sort().join("|");
						if (arr === element.ans) {
							element.anser = {
								id: element.sid,
								answer: arr,
								res: 'succ'
							};
							this.totalScore += parseInt(this.datas.fraction.多选题);
						} else {
							element.anser = {
								id: element.sid,
								answer: arr,
								res: 'err'
							};
						}
					} else if (element.status === 1) {
						if (element.d === element.ans) {
							element.anser = {
								id: element.sid,
								answer: element.d,
								res: 'succ'
							};
							this.totalScore += parseInt(this.datas.fraction.单选题);
						} else {
							element.anser = {
								id: element.sid,
								answer: element.d,
								res: 'err'
							};
						}
					} else {
						if (element.d === element.ans) {
							element.anser = {
								id: element.sid,
								answer: element.d,
								res: 'succ'
							};
							this.totalScore += parseInt(this.datas.fraction.判断题);
						} else {
							element.anser = {
								id: element.sid,
								answer: element.d,
								res: 'err'
							};
						}
					}
				});
				const mergedB = this.finishParmas.answers.reduce((result, obj) => {
					return result.concat(obj.anser);
				}, []);
				let emptyEsCount = mergedB.filter(item => item.answer === '').length;
				this.$confirm('你有' + emptyEsCount + '道题未打完，是否确认交卷?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					closeOnClickModal: false,
					type: 'warning'
				}).then(() => {
					this.lods = true
					this.submit()
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			//提交数据
			submit() {
				this.totalScore = 0
				// 判断是否有题目未答完
				// let isUnanswered = false; // 初始化为 false
				// if (this.countdown != 0) {
				// 	isUnanswered = this.finishParmas.answers.some((element) => {
				// 		if (Array.isArray(element.d)) {
				// 			if (element.d.length === 0) {
				// 				this.lods = false
				// 				return this.$message('有未答完的题，请答完所有题后提交！');
				// 			}
				// 		} else if (element.d === '') {
				// 			this.lods = false
				// 			return this.$message('有未答完的题，请答完所有题后提交！');
				// 		}
				// 	})
				// }

				// 如果存在未答完的题目，则停止往下进行
				// if (isUnanswered) {
				// 	return;
				// }
				// 处理答案逻辑
				this.finishParmas.answers.forEach((element) => {
					this.typs = '';
					element.anser = {};
					console.log(element.status)
					if (element.status === 2) {
						var arr = element.d.sort().join("|");
						if (arr === element.ans) {
							element.anser = {
								id: element.sid,
								answer: arr,
								res: 'succ'
							};
							this.totalScore += parseInt(this.datas.fraction.多选题);
						} else {
							element.anser = {
								id: element.sid,
								answer: arr,
								res: 'err'
							};
						}
					} else if (element.status === 1) {
						if (element.d === element.ans) {
							element.anser = {
								id: element.sid,
								answer: element.d,
								res: 'succ'
							};
							this.totalScore += parseInt(this.datas.fraction.单选题);
						} else {
							element.anser = {
								id: element.sid,
								answer: element.d,
								res: 'err'
							};
						}
					} else {
						if (element.d === element.ans) {
							element.anser = {
								id: element.sid,
								answer: element.d,
								res: 'succ'
							};
							this.totalScore += parseInt(this.datas.fraction.判断题);
						} else {
							element.anser = {
								id: element.sid,
								answer: element.d,
								res: 'err'
							};
						}
					}
				});

				//合并答题卡
				const mergedB = this.finishParmas.answers.reduce((result, obj) => {
					return result.concat(obj.anser);
				}, []);
				console.log(mergedB)
				const targetNum = 'succ';
				let count = 0;
				let mistakes = 0;

				for (let i = 0; i < mergedB.length; i++) {
					if (mergedB[i].res === targetNum) {
						count++;
					} else {
						mistakes++;
					}
				}
				if (this.totalScore >= this.datas.courseConf.num) {
					var is_pass_switch = 1
				} else {
					var is_pass_switch = 2
				}
				var times = this.time - this.countdown
				times = times / 60
				times = Math.round(times);
				this.times2()
				//提交
				this.$http({
						method: 'POST',
						url: '/Exam/updateGrade',
						headers: {
							requireAuth: true // 这里通过设置requireAuth为true来启用token检查
						},
						data: {
							type: 1,
							edu_course_id: this.datas.courseConf.edu_course_id,
							grade: this.totalScore,
							correct: count,
							mistake: mistakes,
							is_pass_switch: is_pass_switch,
							time: times,
							status: 3,
							content: JSON.stringify(mergedB),
							createtime: this.createtime,
							end_time: this.end_time,
						}
					})
					.then(response => {
						clearInterval(this.timer); // 清除定时器
						this.timer = null
						if (response.code == 1) {
							this.lods = false
							this.$router.push({
								path: "/succ",
								query: {
									id: response.data.id,
								}
							})
						} else {
							this.lods = false
							this.$message(response.msg);
						}

					})
					.catch(error => {
						console.log(error)

					})
			}
		}
	};
</script>
<style>
	.el-message-box {
		border-radius: 10px !important;
	}
</style>
<style lang="scss" scoped>
	.bj {
		background-image: url(../../assets/bj.jpg);
		background-repeat: no-repeat;
		background-size: 100% auto;

	}

	.contents {
		width: 1300px;
		height: 214px;
		margin: 0 auto;
	}

	.logo {
		width: 895px;
		height: 91px;
		padding-top: 43px;
	}

	.logo img {
		width: 895px;
		height: 91px;
	}

	.nav {
		width: 100%;
		height: 50px;
		background: #FFFFFF;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
		border-radius: 5px;
		margin-top: 31px;
	}

	.grid-content {
		width: 168px;
		height: 46px;
		float: left;
		line-height: 50px;
		font-size: 18px;
		font-weight: bold;
		color: #1072DA;
		cursor: pointer;
	}

	.grid-content div {
		width: 114px;
		height: 45px;
		margin-left: 10px;

		img {
			width: 20px;
			height: 20px;
			padding-top: 14px;
			float: left;
		}
	}

	.userinfo {
		height: 35px;
		margin-top: 8px;
		cursor: pointer;
		float: right;
		margin-right: 16px;
	}

	.userinfo div:nth-child(1) {
		width: 35px;
		height: 35px;
		float: left;
	}

	.userinfo div:nth-child(1) img {
		width: 35px;
		height: 35px;
		border-radius: 50%;
	}

	.userinfo div:nth-child(2) {
		float: left;
		font-size: 18px;
		color: #4B4B4B;
		line-height: 35px;
		margin-left: 5px;
	}

	.listbut {
		text-align: center;
		width: 100%;
		height: 51px;
		line-height: 51px;
		font-size: 18px;
		color: #333131;
		border-bottom: 1px solid #eee;
		cursor: pointer;
	}

	.listbut:hover {
		background: #eee;
	}

	.el-icon-remove {
		color: #1072DA;
		margin-right: 5px;
		font-size: 20px;
	}

	::v-deep .el-checkbox.is-bordered.el-checkbox--medium {
		height: auto;
		display: flex;
	}

	::v-deep .el-radio--medium.is-bordered {

		max-width: 742px;
		padding: 10px 20px 10px 10px;
		border-radius: 4px;
		height: auto !important;
		min-height: 36px;
	}

	::v-deep .el-radio__label {
		text-overflow: ellipsis;

		white-space: normal;

		line-height: 18px;

		vertical-align: middle;

		display: inline-block;
	}

	::v-deep .el-checkbox__label {
		line-height: 21px !important;
		font-size: 16px !important;
		display: inline-grid;
		width: 700px;
		white-space: pre-line;
		word-wrap: break-word;
	}

	.el-radio {
		margin-top: 10px;
	}

	.el-checkbox {
		margin-top: 10px;
	}

	.exam-top {
		width: 100%;
		height: 88px;
		background-image: url('../../assets/exam/bj.png');
		background-size: 100% 88px;

		div {
			width: 1300px;
			margin: 0 auto;
			padding-top: 4px;

			img {
				width: 650px;
				height: 79px;
			}
		}
	}

	.content {
		width: 1300px;
		margin: 10px auto;
		height: calc(100vh - 310px);
		overflow: hidden;

		.exam-left {
			float: left;
			width: 206px;
			height: 100%;
			background: #FFFFFF;
			border-radius: 5px;
			padding: 0 10px;

			div {
				&:nth-child(1) {
					width: 100%;
					height: 54px;
					line-height: 54px;
					font-size: 18px;
					font-weight: bold;
					color: #1C1D1C;
				}

				&:nth-child(2) {
					width: 100%;
					font-size: 14px;
					font-weight: 400;
					color: #1C1D1C;
				}
			}
		}

		.exam-middle {
			float: left;
			width: 818px;
			height: 100%;
			margin-left: 8px;
			background: #FFFFFF;

			.title {
				width: 100%;
				text-align: center;
				height: 68px;
				line-height: 68px;
				font-size: 22px;
				font-weight: bold;
				color: #434B5F;
			}

			.Tips {
				width: 100%;
				height: 40px;
				line-height: 40px;
				font-size: 13px;
				font-weight: 400;
				color: rgba(0, 0, 0, 0.88);
				background: #FFFBED;

				.el-icon-s-opportunity {
					color: #FFAB00;
					margin-left: 15px;
					margin-right: 5px;
				}
			}

			.Test {
				width: 96%;
				padding: 0 16px;

				.Test-tit {
					height: 70px;
					line-height: 70px;
					font-size: 18px;
					font-weight: 400;
					color: #434B5F;
				}

				.Toggle {
					width: 370px;
					margin: 30px auto;

					div {
						&:nth-child(1) {
							float: left;
						}

						&:nth-child(2) {
							float: right;
						}
					}
				}
			}
		}

		.exam-right {
			float: right;
			width: 239px;
			height: 100%;
			background: #FFFFFF;

			.times {
				height: 139px;

				div {
					&:nth-child(1) {
						height: 60px;
						width: 46px;
						margin: 0 auto;
						padding-top: 15px;

						img {
							width: 46px;
							height: 46px;
						}
					}

					&:nth-child(2) {
						text-align: center;
						height: 16px;
						font-size: 16px;
						font-weight: 400;
						color: #787878;
					}

					&:nth-child(3) {
						margin-top: 9px;
						text-align: center;
						height: 20px;
						font-size: 20px;
						font-weight: 400;
						color: #000000;
					}
				}

			}

			.submits {
				width: 239px;
				height: 81px;
				background: #0662B3;
				cursor: pointer;

				div {
					&:nth-child(1) {
						height: 30px;
						width: 24px;
						margin: 0 auto;
						padding-top: 15px;

						img {
							width: 26px;
							height: 26px;
						}
					}

					&:nth-child(2) {
						font-size: 20px;
						font-weight: 400;
						color: #FFFFFF;
						text-align: center;
					}
				}
			}

			.Answer {
				width: 100%;
				height: 63%;
				overflow-y: auto;
				padding-bottom: 10px;

				.Answer—tits {
					margin-top: 5px;
					margin-left: 10px;
					height: 30px;
					font-size: 14px;
					font-weight: 400;
					color: #505254;
					line-height: 33px;
				}

				.Answer—list {

					.el-tag {
						cursor: pointer;
						text-align: center;
						width: 32px;
						padding: 0;
						margin-left: 13px;
						margin-top: 10px;
					}
				}
			}
		}
	}

	/*滚动条样式*/

	.Answer::-webkit-scrollbar {
		/*滚动条整体样式*/

		width: 2px;
		/*高宽分别对应横竖滚动条的尺寸*/

		height: 4px;

	}

	.Answer::-webkit-scrollbar-thumb {
		/*滚动条里面小方块*/

		border-radius: 5px;

		-webkit-box-shadow: inset005pxrgba(0, 0, 0, 0.2);

		background: rgba(0, 0, 0, 0.2);

	}

	.Answer::-webkit-scrollbar-track {
		/*滚动条里面轨道*/

		-webkit-box-shadow: inset005pxrgba(0, 0, 0, 0.2);

		border-radius: 0;

		background: rgba(0, 0, 0, 0.1);

	}

	.checkbox-overflow {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
</style>